import React from 'react';
import { useSelector } from 'react-redux';
import { selectHasPermission } from '../../../features/auth/authSlice';
import QuickActionCard from './QuickActionCard';

const AdminActions = ({ userRoles }) => {
  // Only select derived permissions that require additional computation
  const hasAuditLogAccess = useSelector((state) => selectHasPermission(state, 'audit_logs:read'));
  const hasUsersAccess = useSelector((state) => selectHasPermission(state, 'users:read'));
  
  // Only render for Admins or users with specific permissions - Early return for performance
  if (!userRoles.includes('Admin') && !hasUsersAccess) {
    return null;
  }

  return (
    <>
      {(userRoles.includes('Admin') || hasUsersAccess) && (
        <QuickActionCard
          to="/users"
          title="User Management"
          description="Manage system users and roles"
          icon={
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
          }
          iconColor="text-blue-600"
          hoverIconColor="group-hover:text-blue-700"
          titleHoverColor="group-hover:text-blue-700"
        />
      )}

      {userRoles.includes('Admin') && (
        <QuickActionCard
          to="/analytics"
          title="System Analytics"
          description="View system performance metrics"
          icon={
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v4a2 2 0 01-2 2h-2a2 2 0 00-2-2z" />
          }
          iconColor="text-purple-600"
          hoverIconColor="group-hover:text-purple-700"
          titleHoverColor="group-hover:text-purple-700"
        />
      )}

      {(userRoles.includes('Admin') || hasAuditLogAccess) && (
        <QuickActionCard
          to="/audit-logs"
          title="Audit Logs"
          description="View system activity logs"
          icon={
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          }
          iconColor="text-green-600"
          hoverIconColor="group-hover:text-green-700"
          titleHoverColor="group-hover:text-green-700"
        />
      )}

      {userRoles.includes('Admin') && (
        <QuickActionCard
          to="/sla-dashboard"
          title="SLA Management"
          description="Comprehensive SLA monitoring and escalation oversight"
          icon={
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          }
          iconColor="text-red-600"
          hoverIconColor="group-hover:text-red-700"
          titleHoverColor="group-hover:text-red-700"
          badge="admin"
        />
      )}
    </>
  );
};

export default React.memo(AdminActions);
